import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  BookingChartDataDTO,
  BookingStatsDTO,
  ChartSearchParams,
  buildParams,
  environment,
} from '@bookly/shared';

@Injectable({
  providedIn: 'root',
})
export class ChartDataApiService {
  readonly #http = inject(HttpClient);
  readonly #chartDataUrl = environment.user.roomBookingApi + '/charts';

  getChartData(
    queryParams?: ChartSearchParams
  ): Observable<BookingChartDataDTO[]> {
    let params;
    if (queryParams) {
      params = buildParams(queryParams);
    }
    return this.#http.get<BookingChartDataDTO[]>(`${this.#chartDataUrl}/data`, {
      params,
    });
  }
  getBookingsStats(): Observable<BookingStatsDTO> {
    return this.#http.get<BookingStatsDTO>(`${this.#chartDataUrl}/stats`);
  }
}
